<article
  class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-4 tw-rounded-lg tw-border tw-border-gray-300 tw-p-4"
>
  <section class="tw-mb-2 tw-flex tw-items-start tw-justify-between tw-gap-4">
    <h3 class="tw-m-0 tw-font-body tw-text-base tw-font-semibold tw-tracking-wider">
      {{ 'landing.news' | translate }}
    </h3>
    @if (!isLoading && newsBlogs.length) {
      <a
        [href]="newsUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="tw-text-sm tw-text-link hover:tw-text-link hover:tw-text-opacity-65"
        >{{ 'common.readMore' | translate }} &rarr;</a
      >
    }
  </section>

  @if (!isLoading) {
    <section class="tw-h-full">
      @if (!isError) {
        <div class="tw-h-full">
          @if (newsBlogs.length) {
            <ul class="tw-flex tw-list-none tw-flex-col tw-gap-4 tw-p-0">
              @for (news of newsBlogs; track news) {
                <li class="tw-rounded-md tw-border tw-border-gray-300">
                  <a
                    [href]="getUrl(news.slug)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="tw-grid tw-w-full tw-grid-cols-4 tw-justify-between tw-text-inherit hover:tw-text-inherit hover:tw-opacity-90"
                  >
                    <div
                      class="tw-col-span-3 tw-flex tw-flex-col tw-justify-between tw-gap-2 tw-p-4"
                    >
                      <h4 class="tw-m-0 tw-line-clamp-2 tw-font-body tw-text-xs">
                        {{ news.title }}
                      </h4>
                      <p class="tw-m-0 tw-line-clamp-2 tw-font-body tw-text-xs">
                        {{ news.excerpt }}
                      </p>
                    </div>
                    <div class="tw-aspect-square tw-col-span-1 tw-w-full tw-object-cover">
                      <img
                        [src]="getFullImageURL(news.coverImage)"
                        [alt]="news.title"
                        class="tw-aspect-square tw-h-full tw-w-full tw-rounded-r-md tw-object-cover"
                      />
                    </div>
                  </a>
                </li>
              }
            </ul>
          } @else {
            <section
              class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center"
            >
              <p class="tw-text-sm">{{ 'dashboard.news.empty' | translate }}</p>
            </section>
          }
        </div>
      } @else {
        <section class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center">
          <p class="tw-text-sm">{{ 'dashboard.news.error' | translate }}</p>
        </section>
      }
    </section>
  } @else {
    <section class="tw-flex tw-flex-col">
      <app-skeleton className="!tw-h-16 tw-rounded-md" />
      <app-skeleton className="!tw-h-16 tw-rounded-md" />
      <app-skeleton className="!tw-h-16 tw-rounded-md" />
    </section>
  }
</article>
